import React from 'react';
import { motion } from 'framer-motion';
import { Check, Download, MessageCircle, BookOpen, Gift } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function WhatYouGet() {
  const benefits = [{
    icon: Download,
    text: 'Ebook PDF (descarga inmediata)'
  }, {
    icon: BookOpen,
    text: 'Ejercicios guiados para reconectar paso a paso'
  }, {
    icon: MessageCircle,
    text: 'Preguntas exactas para conversar sin pelear'
  }, {
    icon: Gift,
    text: '3 bonos exclusivos incluidos en tu compra'
  }];
  return <section className="py-5 bg-white" data-id="element-563">
      <div className="max-w-4xl mx-auto px-6" data-id="element-564">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-565">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2d2d2d] mb-4" data-id="element-566">
            Qué recibo en 30 segundos
          </h2>
          <div className="w-20 h-1 bg-[#9d4b6b] mx-auto rounded-full mb-4" data-id="element-567"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-4 mb-6" data-id="element-568">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#faf8f6] p-4 rounded-2xl border border-[#d4a5a5]/20 flex items-start gap-3 hover:shadow-lg hover:border-[#9d4b6b]/30 transition-all duration-300" data-id="element-569">
              <div className="flex-shrink-0 w-12 h-12 bg-[#9d4b6b] rounded-full flex items-center justify-center" data-id="element-570">
                <Check className="w-6 h-6 text-white" strokeWidth={3} data-id="element-571" />
              </div>
              <div className="flex-1 pt-2" data-id="element-572">
                <p className="text-[#2d2d2d] font-medium text-lg leading-tight" data-id="element-573">
                  {benefit.text}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center" data-id="element-574">
          <CTAButton fullWidth className="mb-3 text-lg py-4" data-id="element-575">
            COMPRAR AHORA
          </CTAButton>

          <p className="text-sm text-[#5a5a5a] flex items-center justify-center gap-2 flex-wrap" data-id="element-576">
            <span className="flex items-center gap-1" data-id="element-577">
              <Download className="w-4 h-4 text-[#9d4b6b]" data-id="element-578" />
              Descarga inmediata por email
            </span>
            <span className="text-[#d4a5a5]" data-id="element-579">•</span>
            <span data-id="element-580">Tarjeta/PayPal</span>
            <span className="text-[#d4a5a5]" data-id="element-581">•</span>
            <span data-id="element-582">100% privado</span>
          </p>
        </motion.div>
      </div>
    </section>;
}